<template>
  <div class="demo-app" :class="{ active: this.demoActive == true }">
    <!--  asdadasds
    {{get_localization_setting}} -->
    <!-- <pre> {{schedulingList}}</pre>  -->
    <!-- {{firstDay}} -->
    <div class="flex items-start w-full">
      <!-- {{CalendarApi}} -->
      <!-- {{name}} -->
      <vs-card class="demo-app-sidebar">
        <button @click="openMenubar" class="nav-btn">
          <span class="material-icons">chevron_right</span>
        </button>
        <div class="leftSidebarContent">
          <!-- <div class="childInherit">
            <vs-input
              class="inputx w-full"
              placeholder="Search"
              v-model="search"
            />
          </div> -->

          <!-- <strong class="block text-lg my-2">{{ name }}</strong> -->
          <strong class="block text-lg my-2">{{ name }}</strong>
          <!-- {{course_filter_id}} -->

          <FilterCheckbox @filterSchedule="filterSchedule" type="student" />

          <v-select
            append-to-body
            class="w-full"
            label="name"
            v-model="course_filter_id"
            :multiple="true"
            :clearable="false"
            :options="courseList"
            :reduce="(item) => item.id"
            placeholder="Enter Course Name"
          ></v-select>
          <ul class="leftx name-list p-0">
            <!-- <li class="modelx">{{ name }}</li> -->
            <!-- {{radios1}} -->
            <!-- <pre>{{studentList}}</pre> -->

            <li class="relative">
              <vs-checkbox
                v-if="studentList.length"
                v-model="allStudents"
                @change="filterAllStudent"
                >All Students</vs-checkbox
              >
              <span v-else>No Students</span>
            </li>
          </ul>

          <div style="max-height: calc(100vh - 205px); overflow: auto;" class="vertical_scrollbar">
            <ul class="leftx name-list p-0">
              <li
                class="relative"
                v-for="(eachStudent, index) in studentList"
                :key="index"
              >
                <!-- <pre>{{eachStudent}}</pre> -->
                <div v-if="eachStudent.client_users">
                  <vs-checkbox
                    v-model="eachStudent.isActive"
                    @change="filterStudentEvent()"
                    :color="eachStudent.colour_code"
                  >
                    <div class="img-holder">
                      <img
                        v-if="eachStudent.client_users.picture"
                        :src="eachStudent.client_users.picture"
                        alt="user-img"
                        width="40"
                        height="40"
                        class="rounded-full shadow-md cursor-pointer block"
                      />
                      <img
                        v-else
                        src="https://st4.depositphotos.com/4329009/19956/v/600/depositphotos_199564354-stock-illustration-creative-vector-illustration-default-avatar.jpg"
                        alt="user-img"
                        width="40"
                        height="40"
                        class="rounded-full shadow-md cursor-pointer block"
                      />
                    </div>
                    <span class="pl-14 inline-block">
                      {{ eachStudent.client_users.first_name }}
                      {{ eachStudent.client_users.last_name }}</span
                    ></vs-checkbox
                  >
                </div>
              </li>
            </ul>
          </div>
        </div>
      </vs-card>

      <div class="demo-app-main">
        <vs-card>
          <!-- <pre>{{arg}}</pre>  -->
          <FullCalendar
            class="demo-app-calendar"
            :options="calendarOptions"
            ref="calendar"
          >
            <!-- Hello -->
            <template v-slot:eventContent="arg">
              <div class="w-full" v-if="arg">
                <!-- <pre>{{arg.event.extendedProps.cstmcolor}}</pre> -->
                <vs-tooltip color="primary" :text="arg.event.extendedProps.course.class_id!=null?arg.event.extendedProps.course.class.name:arg.event.title">
                  <!-- <div class="flex items-center p-1 event-card" :style="{backgroundColor:arg.event.backgroundColor, color:arg.event.extendedProps.cstmcolor}"> -->
                  <div :style="{ backgroundColor: arg.event.backgroundColor + '4a' }" class="event-card p-1">
                    <!-- <img
                      src="/img/avatar-s-11.1a620230.jpg"
                      alt="user-img"
                      width="40"
                      height="40"
                      class="rounded-full shadow-md block mr-1"
                    /> -->
                    <div :style="{ color: arg.event.backgroundColor }" class="flex items-center">
                      <!-- <div
                        class="indicator"
                        :style="{ backgroundColor: arg.event.backgroundColor }"
                      ></div> -->
                      <div class="inline-flex mr-1">
                        <img
                          v-if="arg.event.extendedProps.course.client && arg.event.extendedProps.course.client.picture"
                          :src=" arg.event.extendedProps.course.client.picture"
                          alt="client-img"
                          style="width: 18px; height: 18px; object-fit: contain; border-radius: 100%; background: #9de0e9;"
                          class="rounded-full shadow-md cursor-pointer block"
                        />
                        <img
                          v-else
                          src="https://st4.depositphotos.com/4329009/19956/v/600/depositphotos_199564354-stock-illustration-creative-vector-illustration-default-avatar.jpg"
                          alt="client-img"
                          style="width: 18px; height: 18px; object-fit: contain; border-radius: 100%; background: #9de0e9;"
                          class="rounded-full shadow-md cursor-pointer block"
                        />
                      </div>

                      <!-- <feather-icon icon="ClockIcon" /> -->
                      <div :class="[arg.event.extendedProps.course.badge=='Rescheduled' ? 'rescheduled_holder stat_sch_holder':arg.event.extendedProps.course.badge=='Cancelled' ? 'cancelled_holder stat_sch_holder':'']" v-if="arg.event.extendedProps.course.badge!=null">{{arg.event.extendedProps.course.badge}}</div>
                      <b>{{ arg.timeText }}</b>
                      <!-- <feather-icon icon="UserIcon" /> -->
                      <b class="limitTitle"
                        ><i>{{ arg.event.extendedProps.course.class_id!=null?arg.event.extendedProps.course.class.name:arg.event.title }}</i></b
                      >
                      <p>
                        <i>{{ arg.location }}</i>
                      </p>
                    </div>
                  </div>
                </vs-tooltip>
              </div>
            </template>

            <!-- <template #eventContent="{ timeText, event }">
                     <pre></pre>
                    <b>{{ timeText }}</b>
                    <i>{{ event.title }}</i>
                </template> -->
          </FullCalendar>
        </vs-card>
      </div>
    </div>
    <!-- edit modal -->
    <div v-if="eachEventPopUp">
      <div
        class="
          vs-component
          con-vs-popup
          vs-popup-primary
          cstm-modal-popup
          schedule-popup
        "
        v-if="eachEventPopUp"
        :class="{ show: eachEventPopUp }"
      >
        <div style="max-width: 845px;" class="cstm-modal">
          <div class="header p-0">
            <button @click="eachEventPopUp = false" class="close-modal">
              &times;
            </button>
          </div>
          <!-- <pre>{{eachEventInfo.backgroundColor}}</pre> -->
          <div class="modal-content p-0">
            <event-detail

              :eachEventInfo="eachEventInfo"
              :name="name"
              tabType="Student"
              @refreshSchedule="refreshSchedule"
            ></event-detail>
          </div>
        </div>
      </div>
    </div>
    <div v-if="classPopup">
       <div
        class="
          vs-component
          con-vs-popup
          vs-popup-primary
          cstm-modal-popup
          schedule-popup
        "
        v-if="classPopup"
        :class="{ show: classPopup }"
      >
        <div class="cstm-modal">
          <div class="header">
            <button @click="classPopup = false" class="close-modal">
              &times;
            </button>
          </div>
          <div class="modal-content">
            <class-event-detail
              :classPopup="classPopup"
              :class_id="class_id"
              :eventDetails="eventDetails"
            ></class-event-detail>
          </div>
        </div>
      </div>
    </div>
    <!-- adding event modal -->
    <div v-if="eventAdding">
      <div
        class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup"
        v-show="eventAdding"
        :class="{ show: eventAdding }"
      >
        <div class="cstm-modal">
          <div class="header">
            <h3>Add Event</h3>
            <button @click="eventAdding = false" class="close-modal">
              &times;
            </button>
          </div>
          <div class="modal-content">
            <add-event
              @createEvent="createEvent"
              :startDate="startDate"
              :endDate="endDate"
            ></add-event>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import { INITIAL_EVENTS, createEventId } from './event-utils'
import ListPlugin from '@fullcalendar/list'
import Datepicker from 'vuejs-datepicker'
import AddEvent from './components/AddEvent'
import Testing from './components/Testing'

import EventDetail from './components/EventDetail'
import ClassEventDetail from './components/classEventDetails'

import Editor from '@tinymce/tinymce-vue'
import { eventMixin } from './mixins/eventMixin'

import FilterCheckbox from './components/FilterCheckbox.vue'


import vSelect from 'vue-select'
import { mapGetters } from 'vuex'
export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
    AddEvent,
    Datepicker,
    EventDetail,
    editor: Editor,
    Testing,
    FilterCheckbox,
    vSelect,
    ClassEventDetail
  },
  mixins: [eventMixin],
  props: {
    name: {
      type: String,
      required: true,
      eachEventPopUp: false
    }
  },

  created () {
    this.tinyMceApi = process.env.VUE_APP_TINYMCE_API
    /*  this.radios1.fill('add', 0, 10)
    for (let i = 0; i < 10; i++) {

      this.radios1.push(false)
    } */
    this.fetchingStudentList()
    this.fetchCourseWithList()
    this.fetchingEvent(null, 'student')
    /* if (this.get_localization_setting) {
      this.calendarOptions.firstDay = this.get_localization_setting.start_day_id
    } */
  },
  computed: {
    ...mapGetters(['get_localization_setting'])
  },
  watch: {
    get_localization_setting: {
      immediate: true,
      deep: true,
      handler () {
        console.log('HI I ma herer')
        console.log(this.get_localization_setting)
        if (this.get_localization_setting) {
          this.calendarOptions.firstDay =
            this.get_localization_setting.start_day_id
        }
      }
    },
    course_filter_id: {
      deep: true,
      handler () {
        this.fetchingStudentList(this.course_filter_id, 'true')
      }
    }
  },
  mounted () {
    this.calendarApi = this.$refs.calendar.getApi()

  },
  data () {
    return {
      classPopup:false,
      class_id:null,
      eventDetails:null,
      nothing: '',
      search: 'sad',
      event: null,
      startDate: null,
      endDate: null,
      eachEventPopUp: false,
      eventAdding: false,
      title: '',
      picked: 1,
      // radios1: [],
      eachEventInfo: null,
      calendarOptions: {
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
          ListPlugin // needed for dateClick
        ],
        firstDay: 0,
        views: {
          week: {
            titleFormat: this.changeDateFormat,
            dayHeaderFormat:this.changeDateFormat
          },
          month: {
            titleFormat: this.changeDateFormat
          },
          day: {
            titleFormat: this.changeDateFormat
          },
          today: {
            titleFormat: this.changeDateFormat
          }

        },
        customButtons: {
          previousButton: {
            text: '<',
            click: () => {
              this.previousMonth('student')
            }
          },
          nextButton: {
            text: '>',
            click: () => {
              this.nextMonth('student')
            }
          },
          todayButton: {
            text: 'Today',
            click: () => {
              this.today('student')
            }
          }
        },
        headerToolbar: {
          left: 'previousButton,nextButton todayButton',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
        },
        eventLimit: false, // for all non-TimeGrid views
        events: [],
        initialView: 'dayGridMonth',
        editable: true,
        selectable: true,
        selectMirror: true,
        dayMaxEvents: true,
        eventTimeFormat: {
          // like '14:30'
          hour: '2-digit',
          minute: '2-digit',
          meridiem: false
        },
        // INITIAL_EVENTS:this.events,
        weekends: true,
        // select: this.handleDateSelect,
        eventClick: this.handleEventClick,
        eventsSet: this.handleEvents
        /* you can update a remote database when these fire:
        eventAdd:
        eventChange:
        eventRemove:
        */
      },
      allStudents: true,

      currentEvents: [],
      demoActive: false,
      schedulingList: [],
      eachMonthEventData: [],
      calendarApi: '',
      attendance: 'present'
    }
  },
  methods: {
    async refreshSchedule () {
      this.fetchingEvent(null, 'student')
      this.eachEventPopUp = false
      this.eachEventInfo = null
    },
    // getContrast (hexcolor) {
    //   //
    //   hexcolor = hexcolor.replace('#', '')
    //   const r = parseInt(hexcolor.substr(0, 2), 16)
    //   const g = parseInt(hexcolor.substr(2, 2), 16)
    //   const b = parseInt(hexcolor.substr(4, 2), 16)
    //   const yiq = (r * 299 + g * 587 + b * 114) / 1000
    //   return yiq >= 128 ? '#000000' : '#ffffff'
    // },
    handleWeekendsToggle () {
      this.calendarOptions.weekends = !this.calendarOptions.weekends // update a property
    },
    handleDateSelect (selectInfo) {
      this.startDate = selectInfo.startStr
      this.endDate = selectInfo.endStr
      //
      this.eventAdding = true
    },
    handleEventClick (clickInfo) {
      this.eachEventInfo = clickInfo.event
      if (clickInfo.event.title !== null && clickInfo.event.title !== '') {
        this.eachEventPopUp = true
      } else {
        this.classPopup = true
        this.eventDetails = clickInfo.event
        this.class_id = clickInfo.event.extendedProps.course.class_id
      }
    },
    handleEvents (events) {
      this.currentEvents = events
    },
    createEvent (obj) {
      //

      INITIAL_EVENTS.push({
        id: createEventId(),
        title: obj.title,
        start: `${obj.course_start} ${obj.course_start_time}`,
        // startTime: obj.course_start_time,
        end: `${obj.course_end} ${obj.course_end_time}`,
        backgroundColor: obj.eventTextColor,
        location: obj.location,
        eventTypePicked: obj.eventTypePicked
      })

      this.showSuccessMessage('Success', 'Event Added Successfully', 'success')
      setTimeout(() => {
        this.eventAdding = false
      }, 0)
      /*   setTimeout(() => {
        this.eventAdding = false

      }, 1000) */

      // this.$refs.calendar.$emit('refetch-events')
    },
    openMenubar () {
      this.demoActive = !this.demoActive
    }
  }
}
</script>

<style lang='css'>
h2 {
  margin: 0;
  font-size: 16px;
}
/* ul {
  margin: 0;
  padding: 0 0 0 1.5em;
}
li {
  margin: 1.5em 0;
  padding: 0;
} */
b {
  /* used for event dates/times */
  /* margin-right: 3px; */
}
.fc {
  /* the calendar root */
  max-width: 100%;
}
.childInherit {
  width: inherit;
}

.teacher-info {
  display: inherit;
  min-width: 50%;
  border: 1px solid #eee;
  padding: 10px;
}
.bg-light-grey {
  background: #f3f3f3;
  padding: 5px;
  margin: 0 5px;
  border-radius: 5px;
}
.tox-tinymce-aux {
  z-index: 100000 !important;
}

/* .name-list img {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  z-index: 1;
} */
.event-card {
  border-radius: 4px;
  /* background-color: #41ccdf;
  color: #fff;
  border-width: 3px 0 0 0;
  border-style: solid;
  border-color: transparent; */
}
/* .fc-event-today {
  border: none;
  background-color: transparent;
}
.fc-event-today .event-card {
  background-color: #ccc;
}
.fc-event-today .indicator {
  display: none;
} */
.event-card .feather-icon {
  width: 12px;
  margin-right: 2px;
}
.event-card .limitTitle {
  display: inline-block;
  width: calc(100% - 45px);
  overflow: hidden;
  text-overflow: ellipsis;
}
.indicator {
  width: 7px;
  height: 7px;
  margin-right: 3px;
  border-radius: 50%;
}

/* td.fc-daygrid-day {
  height: 200px;
} */

@media (max-width: 480px) {
  .teacher-info {
    min-width: 100%;
  }
}
</style>

